import { render, staticRenderFns } from "./W2Generator.vue?vue&type=template&id=080a45bc&"
import script from "./W2Generator.vue?vue&type=script&lang=js&"
export * from "./W2Generator.vue?vue&type=script&lang=js&"
import style0 from "./W2Generator.vue?vue&type=style&index=0&id=080a45bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports